'use client'

import { useCallback, useEffect, useRef, useState } from 'react'

import { Measure } from '@/components/ui/measure'
import { PosMockupScreenBistro } from './pos-mockup-screen-bistro'
import { PosMockupScreenHighlands } from './pos-mockup-screen-highlands'
import { PosMockupScreenTpc } from './pos-mockup-screen-tpc'

const AUTO_SWITCH_MS = 5000

export function PosMockupSlider({ mockupLabel }: { mockupLabel: string }) {
  const [index, setIndex] = useState(0)
  const autoRef = useRef<ReturnType<typeof setInterval> | null>(null)

  const tickClock = useCallback(() => {
    const timeString = new Date().toLocaleTimeString('en-GB', { hour12: false })
    document.querySelectorAll('.pos-time').forEach((el) => {
      el.textContent = timeString
    })
  }, [])

  useEffect(() => {
    tickClock()
    const id = setInterval(tickClock, 1000)
    return () => clearInterval(id)
  }, [tickClock])

  const startAuto = useCallback(() => {
    if (autoRef.current) clearInterval(autoRef.current)
    autoRef.current = setInterval(() => {
      setIndex((i) => (i + 1) % 3)
    }, AUTO_SWITCH_MS)
  }, [])

  useEffect(() => {
    startAuto()
    return () => {
      if (autoRef.current) clearInterval(autoRef.current)
    }
  }, [startAuto])

  const translatePercent = -(index * (100 / 3))

  return (
    <div className="pos-mockup-wrapper w-full py-8">
      <Measure
        size="5xl"
        className="relative w-full rounded-3xl bg-charcoal-900 p-4 sm:p-6 ui-mockup-shadow ui-mockup-shadow-central-pos"
      >
        <div className="absolute left-1/2 top-3 z-20 flex -translate-x-1/2 transform items-center gap-2">
          <div className="h-2 w-2 rounded-full bg-charcoal-700" />
          <div className="h-1 w-1 rounded-full bg-green-500/50" />
        </div>

        <div className="relative h-[600px] w-full overflow-hidden rounded-xl border border-charcoal-800 bg-gray-100">
          <div
            className="flex h-full w-[300%] transition-transform duration-700 ease-in-out"
            style={{ transform: `translateX(${translatePercent}%)` }}
          >
            <PosMockupScreenBistro />
            <PosMockupScreenHighlands />
            <PosMockupScreenTpc />
          </div>
        </div>

        <p className="mt-3 text-center font-mono text-xs text-charcoal-500">
          {mockupLabel}
        </p>
      </Measure>
    </div>
  )
}
